import 'regenerator-runtime'
import {EventBus, EventTypes} from '../consts/const-event-types'

import App from '../components/app'
import EventFilter from '../components/event/event-filter';

const components = [
  {Class: App, selectorName: 'app'},
  {Class:EventFilter, selectorName: 'event-filter'},
]


class ComponentInstantiator {
  constructor() {
    this.createComponents()
    this.dispatchReady()
    return this
  }

  createComponents() {
    this.componentsInstantiated = {}

    components.map(component => {
      const nodes = []
      // select all DOM-nodes with the data-component attribute:
      const nodeItems = [...document.querySelectorAll("[data-component='" + component.selectorName + "']")]

      nodeItems.map(nodeItem => {
        // instantiate component with nodeItem as param:
        nodes.push(new component.Class(nodeItem))
      })

      // add to componentsList object:
      if (nodes.length) this.componentsInstantiated[component.selectorName] = nodes
    })
  }

  dispatchReady() {
    const event = new CustomEvent(EventTypes.ALL_COMPONENTS_READY)
    EventBus.dispatchEvent(event)
  }

  getComponents(selectorName) {
    return selectorName ? this.componentsInstantiated[selectorName] : this.componentsInstantiated
  }
}

 if ("serviceWorker" in navigator) {
  window.addEventListener("load", function() {
    navigator.serviceWorker
      .register("../serviceWorker.js")
      .then(res => {})
      .catch(err => console.log("service worker not registered", err))
  })
}

window.App = new ComponentInstantiator()

